/* eslint-disable no-unused-expressions */
import { Outlet } from 'react-router-dom';
import './layout-v2.scss';
import BuildButton from "../v2/components/BuildButton";
import { useScrollToTopV2 } from "../components/app/ScrollToTop";
import MainSidebar from "./MainSidebar";
import { ReactNode, useContext } from "react";
import { GlobalSettingsContext } from "../v2/context/global-settings";
import { HiChevronDoubleLeft, HiChevronDoubleRight } from "react-icons/hi";
import SearchBar from "../v2/components/search-bar/SearchBar";




const LayoutV2 = ({
  children
}: {
  children?: ReactNode
}) => {
  useScrollToTopV2();
  const { isMiniSidebar, toggleMiniSidebar } = useContext(GlobalSettingsContext);


  return <div className="flex min-w-[1240px]">
    {/* left sidebar */}
    <MainSidebar />
    {/* mainContent */}
    <div className="flex-1 max-h-screen overflow-auto">
      {/* globalactions */}
      <div className="flex justify-between h-10 border-b-2 items-center bg-[#fff]">
        <div className="flex items-center px-3 border-r-2">
          <div className="border-r h-[36px] flex items-center pr-3 mr-3">
            {
              !isMiniSidebar ? <div className="cursor-pointer" >
                <HiChevronDoubleLeft onClick={toggleMiniSidebar} />
              </div> : <div className="cursor-pointer" >
                <HiChevronDoubleRight onClick={toggleMiniSidebar} />
              </div>
            }
          </div>
          <div className="w-[350px]">
            <SearchBar width="w-full" showBorder={false} />
          </div>
        </div>
        <div className="flex-1"></div>
        <div className="">
          <BuildButton />
        </div>
      </div>

      <div className="h-[calc(100vh-40px)] overflow-auto bg-[#fff]" id="subpage">
        {
          children || <Outlet />
        }
      </div>
    </div>
  </div>
}


export default LayoutV2;